<template>
  <div class="of-box" style="margin-top: 0;margin-left: 0;padding-left: 0;padding-top: 0;">
    <div class="of-container is-vertical base-page-box4">
      <div class="of-aside base-search-box ">
        <div class="of-filter clearfix">
          <div class="filter-left">

          </div>
          <div class="filter-right">
          </div>
        </div>
      </div>
      <div ref="odtableBox" class="of-main no-scroll">
        <div class="of-table" style="padding:0">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="boxHeight"
            :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect>
            <el-table-column v-for="(item, index) in tableCols" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" :content="`${scope.row[item.prop]}`"
                  placement="bottom" effect="light">
                  <span>{{ scope.row[item.prop]}}</span>
                </el-tooltip>
                <span v-else>{{scope.row[item.prop] }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination :total="total" :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex" @change="pageChange"></my-pagination>
      </div>
    </div>

  </div>
</template>
<script>
import { getOtherdataList } from '@/modules/contract/api/freightnew.js'
import MyPagination from "@/components/pagination"
export default {
  name: 'Step4Page',
  components: {
    MyPagination
  },
  props: {
    bform: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data () {
    return {
      importVisible: false,
      isImportSubmit: false,
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'asc',
        sortField: 'DispatchDate',
        fastSearchFields: 'Vehicle',
        fastSearchKeyWord: '',
        MakeReportId: '',
      },
      issubmit: false,
      boxHeight: 400,
      total: 0,
      tableCols: [
        { label: '计划日期', prop: 'DispatchDate', width: '100', type: '' },
        { label: '类型', prop: 'VehicleType', width: '100', type: '', shwotip: true },
        { label: '趟次编号/设备号', prop: 'Vehicle', width: '120', type: '', shwotip: true },
        { label: '运作顺序', prop: 'RunSerial', width: '120', type: '', shwotip: true },
        { label: '费用类型', prop: 'DataType', width: '120', type: '', shwotip: true },
        { label: '费用', prop: 'FixedVal', width: '120', type: '', shwotip: true },
        { label: '备注', prop: 'Remark', width: '', type: '', shwotip: true },
        { label: '创建人', prop: 'CreatorName', width: '150', type: '', sortable: true },
        { label: '创建时间', prop: 'CreateDate', width: '150', type: '', sortable: true },
      ],
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
      binfo: null,
    }

  },
  computed: {},
  mounted () {
    if (this.bform) {
      this.pageQuery.MakeReportId = this.bform.Id
      this.boxHeight = 400
      this.loadPageData()
    }
  },
  methods: {
    loadPageData () {
      this.isloading = true
      getOtherdataList(this.pageQuery).then(res => {
        this.isloading = false
        if (res.data.Code === 0) {
          this.listData = res.data.Data.rows.map(p => { return { ...p, DispatchDate: this.datetime(p.DispatchDate, 'YYYY-MM-DD') } })
          this.total = res.data.Data.total
        }
      })
    },

    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },
  }
}
</script>

<style></style>
